import { Component, ViewChild } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ExportServices } from "../../services/exportServices";
import { CustomersServices } from "../services";
import { CustomersCreateDataPage } from "../customers-create/customers-create-data/customers-create-data";
import { TranslateService } from '@ngx-translate/core';
import { CustomersCreateInfoPage } from '../customers-create/customers-create-info/customers-create-info';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { ConfigurationIntegrationsPage } from '../../configuration/configuration-integrations/configuration-integrations';
import { ImportExcelPage } from '../../components/import-excel/import-excel';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';

/**
 * Generated class for the CustomersListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-customers-list',
  templateUrl: 'customers-list.html',
})
export class CustomersListPage {

  searchbar_text: string = '';


  loader = true;
  total_customers = 0;
  news_customers = [];
  average_customer_consumption = 0;
  average_customer_visits = 0;
  usual_customers = [];
  usual_customers_sin_desplegar = [];
  usual_customers_desplegado = [];

  news_customers_sin_desplegar = [];
  news_customers_desplegado = [];

  show_usual_customers = false;
  show_new_customers = false;

  //datatable
  sorts = [
    { prop: 'name', dir: 'asc' },
    { prop: 'address', dir: 'asc' },
    { prop: 'email', dir: 'asc' },
    { prop: 'phone', dir: 'asc' }
  ];
  @ViewChild(DatatableComponent) table: DatatableComponent;
  ColumnMode = ColumnMode;
  config_msg = {
    emptyMessage: this.translate.instant('general-no-hay-datos'),
    totalMessage: this.translate.instant('general-total'),
    selectedMessage: this.translate.instant('general-seleccionado')
  };

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public exportServices: ExportServices,
    public customersServices: CustomersServices,
    public translate: TranslateService,
    public http: HttpClient) {
    this.globals.GAtrackView('Customers', 'Customers - View ', this.globals.restaurant.email, 'View', 'List customers', 'Customers', '');
    this.customersServices.customer_searchbar_text = '';
    this.customersServices.customers_array_filtered = this.customersServices.customers_array_tmp;
  }

  ionViewWillEnter() {
    if (!this.globals.checkLimitsByLicense('sales', 'customers')) {
      this.navCtrl.pop();
      this.navCtrl.push(AddonsTriggerVersionProPage);
    } else {
      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-cargando-clientes')
      });
      loadingPopup.present();
      this.customersServices.getNodeCustomers();
      loadingPopup.dismiss();
      if (this.globals.checkLimitsByLicense('sales', 'customers_analytics')) {
        this.getAnalyticsReservations();
      } else {
        this.loader = false;
      }
    }
  }

  openCustomerCreate() {
    this.navCtrl.push(CustomersCreateInfoPage, {
      update_state: false,
    });
  }

  openCustomer(customer) {
    this.navCtrl.push(CustomersCreateDataPage, {
      update_state: true,
      customer_uid: customer.UID,
      name: customer.name,
      business_name: customer.business_name,
      business_number: customer.business_number,
      email: customer.email,
      phone: customer.phone,
      address: customer.address,
      note: customer.note,
      alegra_contact_id: customer.alegra_contact_id,
    })
  }

  async exportCustomers() {

    if (this.globals.checkLimitsByLicense('sales', 'customers')) {//version pro abierto

      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: ''
      });
      loadingPopup.present();

      const body = new HttpParams()
        .set('public_key', this.globals.public_key);

      await this.http.post(this.globals.analytics_path + 'customers/customers_export', body).subscribe(async data => {
        //abrir para descargar
        if (this.globals.so_mobile) {
          window.location.assign(String(data['media_link']));
        } else {
          window.open(String(data['media_link']), '_blank');
        }
        //dismiss
        loadingPopup.dismiss();

      },
        err => {
          loadingPopup.dismiss();
        });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  openCustomerInt() {
    if (this.globals.returnRolAccess(this.globals.user_rol, 'integrations')) {
      this.globals.side_menu_config_active = 'integrations';
      this.navCtrl.push(ConfigurationIntegrationsPage);
    }
  }

  async getAnalyticsReservations() {
    this.loader = true;

    const body = new HttpParams()
      .set('public_key', this.globals.public_key);

    await this.http.post(this.globals.analytics_path + 'customers/get_analytics_customers', body).subscribe(async res => {


      this.total_customers = res['total_customers'];
      this.news_customers = res['news_customers'];

      this.average_customer_consumption = this.globals.round2decimal(res['average_customer_consumption']);
      this.average_customer_visits = this.globals.round2decimal(res['average_customer_visits']);

      this.usual_customers_sin_desplegar = res['usual_customers_sin_desplegar'];
      this.usual_customers_desplegado = res['usual_customers_desplegado'];

      this.news_customers_sin_desplegar = res['news_customers_sin_desplegar'];
      this.news_customers_desplegado = res['news_customers_desplegado'];
      this.loader = false;

    },
      err => {
      });
  }


  change_show_usual_customers() {
    this.show_usual_customers = !this.show_usual_customers
  }

  change_show_new_customers() {
    this.show_new_customers = !this.show_new_customers
  }

  importCustomers(type) {
    this.navCtrl.push(ImportExcelPage, {
      type: type
    });
  }

  clickElement(event) {
    if (event.type == 'click') {
      this.navCtrl.push(CustomersCreateDataPage, {
        update_state: true,
        customer_uid: event.row.UID,
        name: event.row.name,
        business_name: event.row.business_name,
        business_number: event.row.business_number,
        email: event.row.email,
        phone: event.row.phone,
        address: event.row.address,
        note: event.row.note,
        alegra_contact_id: event.row.alegra_contact_id,
      });
    }
  }

  onSort(event) {

    var customers_array = this.customersServices.customers_array_filtered;

    switch (event.column.name) {
      case 'name':
        if (event.newValue == 'asc') {
          customers_array.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          customers_array.sort((a, b) => b.name.localeCompare(a.name));
        }
        break;
      case 'address':
        if (event.newValue == 'asc') {
          customers_array.sort((a, b) => a.address.localeCompare(b.address));
        } else {
          customers_array.sort((a, b) => b.address.localeCompare(a.address));
        }
        break;
      case 'email':
        if (event.newValue == 'asc') {
          customers_array.sort((a, b) => a.email.localeCompare(b.email));
        } else {
          customers_array.sort((a, b) => b.email.localeCompare(a.email));
        }
        break;
      case 'phone':
        if (event.newValue == 'asc') {
          customers_array.sort((a, b) => a.phone.localeCompare(b.phone));
        } else {
          customers_array.sort((a, b) => b.phone.localeCompare(a.phone));
        }
        break;
    }

    this.customersServices.customers_array_filtered = customers_array;
  }
}


// WEBPACK FOOTER //
// ./src/pages/customers/customers-list/customers-list.ts